import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';



function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function BasicBreadcrumbs() {
  return (
    <div role="presentation" onClick={handleClick}>
      <Breadcrumbs separator="›" aria-label="breadcrumb" color="white">
        <Link underline="hover" color="#009d9e" href="../">
          Home
        </Link>
        <Typography color="#777">Our Work</Typography>
      </Breadcrumbs>
    </div>
  );
}
